import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Modal } from 'antd';
import { LoadingSpinner } from './loading-spinner/loading-spinner';
import Typography from '../helpers/fonts';
import { useUiState } from '../state/ui-state/ui-state';
import { useSmallScreen } from '../helpers/isSmallScreen';
import { useTranslation } from 'react-i18next';
import { ReactComponent as HouseIcon } from '../assets/house_icon.svg';

export const ViewerLoadingMessage: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { viewerFirstLoading, isFromWebsite } = useUiState();
  const isSmallScreen = useSmallScreen();

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 2,
        margin: isSmallScreen ? 0 : 20,
      }}
    >
      <div style={{ display: 'grid' }}>
        <AnimatePresence>
          <div style={{ gridArea: '1 / 1' }}>
            {viewerFirstLoading && (
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                style={{
                  padding: '1px 3px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#fff',
                  borderRadius: 5,
                }}
              >
                <Modal
                  centered
                  visible={true}
                  title={''}
                  footer={''}
                  closeIcon={<></>}
                >
                  <div style={{display: 'flex', justifyContent: 'center', position: 'relative', margin: '0 0 1rem', }}>
                    <LoadingSpinner
                      style={{ height: 68, width: 68, color: '#7A9C49' }}
                    />
                    <HouseIcon
                      style={{
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)'
                      }}
                    />
                  </div>
                  <p style={{ whiteSpace: 'pre-line' }}>
                    <Typography styleid={6}>
                      {t(isFromWebsite ? 'viewerLoading.infoWebsiteRedirect' : 'viewerLoading.info')}
                    </Typography>
                  </p>
                  <p>
                    <Typography styleid={6}>
                      <span style={{ color: '#7A9C49' }}>Please note: </span>In this version{" "}
                      <span style={{ textDecoration: 'underline' }}>the interior materials shown are not accurate.</span> If you’re curious
                      please visit inspiration {">"} interiors on our website for more information.
                    </Typography>
                  </p>
                </Modal>
              </motion.div>
            )}
          </div>
        </AnimatePresence>
      </div>
    </div>
  )
}
